const moneyFormatter = new Intl.NumberFormat(Shopify.locale, { style: 'currency', currency: Shopify.currency.active });
class CartRule {
	constructor({ ruleType, ruleID, giftVariantID, productTitle, shippingPrice, remainingText, threshold }) {
		this.ruleType = ruleType;
		this.ruleID = ruleID;
		this.giftVariantID = giftVariantID;
		this.productTitle = productTitle;
		this.shippingPrice = parseFloat(shippingPrice) || 0;
		this.remainingText = remainingText;
		this.threshold = parseFloat(threshold) || 0;
	}
	isRuleQualified({ cartTotal, discountedPricePerOrder }) {
		if (!cartTotal || !this.threshold) return false;
		if (this.ruleType === 'GIFT_BAR_ITEM_DISCOUNT') {
			return cartTotal + discountedPricePerOrder >= this.threshold;
		}
		return cartTotal >= this.threshold;
	}
	getShippingPrice({ cartTotal }) {
		if (this.ruleType !== 'GIFT_BAR_ITEM_SHIPPING' || !this.shippingPrice) return null;
		return this.isRuleQualified({ cartTotal }) ? 0 : this.shippingPrice;
	}
	getGiftVariantID() {
		if (this.ruleType !== 'GIFT_BAR_ITEM_GIFT' || !this.giftVariantID) return null;
		return this.giftVariantID;
	}
	isRuleGiftRemoved(removedItemIds) {
		if (this.ruleType !== 'GIFT_BAR_ITEM_GIFT' || !this.giftVariantID || !removedItemIds) return false;
		return removedItemIds.includes(this.giftVariantID);
	}
	getUpdatePayload({ cartTotal, lineItems, removedItemIds }) {
		if (this.ruleType !== 'GIFT_BAR_ITEM_GIFT' || !this.giftVariantID) return null;
		const giftIsInCart = lineItems.some((item) => item.variant_id === this.giftVariantID);
		const isQualified = this.isRuleQualified({ cartTotal });
		if (giftIsInCart && !isQualified) {
			return { id: this.giftVariantID, quantity: 0 };
		}
		if (!giftIsInCart && isQualified) {
			return { id: this.giftVariantID, quantity: 1 };
		}
		return null; // No update needed
	}
	getRemainingPrice({ cartTotal }) {
		if (!this.threshold || !cartTotal) return 0;
		const remaining = this.threshold - cartTotal;
		return remaining > 0 ? remaining : 0;
	}
	getFormattedRemainingText({ cartTotal }) {
		const remainingPrice = this.getRemainingPrice({ cartTotal });
		if (this.remainingText) {
			this.remainingText = this.remainingText.replace('{product_title}', this.productTitle || '');
		}
		return this.remainingText.replace(
			'{remaining_price}',
			moneyFormatter.format(remainingPrice / 100).replace(/\$/g, '$$$$'),
		);
	}
}

export { CartRule };
